const PREFIX = 'MythicResizableGrid';
export const classes = {
    headerCellRow: `${PREFIX}-headerCellRow`,
    headerCell: `${PREFIX}-headerCell`,
    hoveredRow: `${PREFIX}-hoveredRow`,
    cell: `${PREFIX}-cell`,
    cellInner: `${PREFIX}-cellInner`,
    draggableHandlesContainer: `${PREFIX}-draggableHandlesContainer`,
    draggableHandlesClickArea: `${PREFIX}-draggableHandlesClickArea`,
    draggableHandlesClickAreaSelected: `${PREFIX}-draggableHandlesClickAreaSelected`,
    draggableHandlesIndicator: `${PREFIX}-draggableHandlesIndicator`,
}
